import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import Tab from 'components/_parts/atoms/tab';
import TabList from './tabList';

function TitleBp({
  child, typeModal, typeTree, datas, t, tabValue, setTabValue, parentLevel,
}: any) {
  // const { tab: tabs } = queryString.parse(location.search);
  const tabList = TabList();

  const newTypeTree: { [val: string]: string } = {
    add_next: t('biz_process.add_next_bp'),
    add_previous: t('biz_process.add_prev_bp'),
  };

  const labelAdd: { [value: number]: string } = {
    1: 'primary',
    2: 'steering',
    3: 'support',
  };

  const labelEdit: { [value: string]: string } = {
    'Primary Process': 'primary',
    'Steering Governance': 'steering',
    'Support Process': 'support',
  };

  const colorLabel: { [value: number]: string } = {
    1: 'color_primary',
    2: 'color_steering',
    3: 'color_support',
  };

  const colorLabelChild: { [value: string]: string } = {
    'Primary Process': 'color_primary',
    'Steering Governance': 'color_steering',
    'Support Process': 'color_support',
  };

  const isHideSubLabel = child === undefined && typeTree === undefined && parentLevel !== 1;

  const mainLabel = `${datas ? t('biz_process.tree.edit') : t('biz_process.tree.form.add')} ${t('biz_process.name')}`;

  let subLabel = '';
  let colorSubLabel = '';

  if (datas !== undefined) {
    subLabel = labelEdit[datas.type];
    colorSubLabel = colorLabelChild[datas.type];
  } else {
    subLabel = labelAdd[typeModal];
    colorSubLabel = colorLabel[typeModal];
  }

  return (
    <>
      {child === undefined && typeTree === undefined && (
      <div className="header_bispro">
        <div className="label_bispro tw-mb-2" style={{ flex: '0 0 60%' }}>
          <Label typeLabel="label_modal">
            {mainLabel}
          </Label>
          {!isHideSubLabel && (
            <Label
              className={`label_bispro-type color_primary ${colorSubLabel}`}
              typeLabel=""
            >
              {subLabel}
            </Label>
          )}
        </div>
        <div style={{ flex: '0 0 40%', margin: 'auto' }}>
          <Tab
            data={tabList}
            tab={tabValue}
            setTab={setTabValue}
            className="tab_title-sm"
            style={{ marginBottom: '0px' }}
          />
        </div>
      </div>
      )}

      {child !== undefined && typeTree === undefined && (
        <div className="header_bispro-child">
          <div className="label_bispro-grid">
            <div>
              <Label typeLabel="label_modal">
                {t('biz_process.add_child_bp')}
              </Label>
            </div>
            <Label
              className={`label_bispro-type color_primary ${colorLabelChild[child.type]}`}
              typeLabel=""
            >
              {labelEdit[child.type]}
            </Label>
            <Label typeLabel="label_modal2">{child.name}</Label>
          </div>
          <div style={{ flex: '0 0 36%', margin: 'auto' }}>
            <Tab
              data={tabList}
              tab={tabValue}
              setTab={setTabValue}
              className="tab_title-sm"
              style={{ marginBottom: '0px' }}
            />
          </div>
        </div>
      )}

      { typeTree !== undefined && child !== undefined && (
      <div className="header_bispro-child">
        <div className="label_bispro-grid">
          <div>
            <Label typeLabel="label_modal">{newTypeTree[typeTree]}</Label>
          </div>
          <Label
            className={`label_bispro-type color_primary ${colorLabelChild[child.type]}`}
            typeLabel=""
          >
            {labelEdit[child.type]}
          </Label>
          <Label typeLabel="label_modal2">{child.name}</Label>
        </div>
        <div style={{ flex: '0 0 36%', margin: 'auto' }}>
          <Tab
            data={tabList}
            tab={tabValue}
            setTab={setTabValue}
            className="tab_title-sm"
            style={{ marginBottom: '0px' }}
          />
        </div>
      </div>
      ) }
    </>
  );
}

export default TitleBp;
